export default "__VITE_ASSET__Lzu5IWim__"